/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaSuperSelect/view.blocks to change it.
import Children from 'Simple/Children'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TysiaSuperSelect({
  children,
  viewPath = "/DesignSystem/TysiaSuperSelect",
  alignSelf = "flex-start",
  flexGrow = 1,
  marginTop = 16,
  marginRight = 0,
  marginBottom = 0,
  marginLeft = 0,
  maxWidth,
  onMouseEnter,
  onMouseLeave,
  from,
  id,
  size,
  dock,
  focused,
  disabled,
  hovered,
  invalid,
  valid,
  placeholder,
  value,
  onBlur,
  onFocus,
  onChange,
  onSubmit
  
}) {
  return (<React.Fragment
>
<div
  data-testid="TysiaSuperSelect.Vertical"
  data-view-path={viewPath}
 onMouseEnter={onMouseEnter}
 onMouseLeave={onMouseLeave}
 style={{'--as-1-Z23ddwc': alignSelf,'--fg-2-Z23ddwc': flexGrow,'--mt-3-Z23ddwc': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mr-4-Z23ddwc': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--mb-5-Z23ddwc': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-6-Z23ddwc': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mw-7-Z23ddwc': typeof maxWidth === 'number' ? `${maxWidth}px` : maxWidth}}
 className={`views-block ${styles.Vertical}`}
>
<Children
  viewPath={`${viewPath}/Children`}
 from={from}
 id={id}
 size={size}
 dock={dock}
 focused={focused}
 disabled={disabled}
 hovered={hovered}
 invalid={invalid}
 valid={valid}
 placeholder={placeholder}
 value={value}
 onBlur={onBlur}
 onFocus={onFocus}
 onChange={onChange}
 onSubmit={onSubmit}
>
{children}
</Children>
</div>
</React.Fragment>)
}